import React from 'react'
import { useWillPipe } from '@morningtrain/react-helpers'
import denomination from 'support/helpers/denomination'

export default function PurchaseEventOnPipe () {
  const format = denomination

  useWillPipe(payload => new Promise(resolve => {
    if (window.dataLayer && payload && payload.responses && payload.responses.purchase && payload.responses.purchase.model) {
      const order = payload.responses.purchase.model
      let products = order.links || []

      products = products.reduce((acc, product) => {
        const index = acc.findIndex(p => p.id === product.domain_id)

        if (index > -1) {
          acc[index].quantity++
        } else {
          acc.push({
            id: product.domain_id,
            name: product.domain.domain,
            price: format(product.true_price_paid),
            quantity: 1
          })
        }

        return acc
      }, [])

      window.dataLayer.push({
        event: 'purchase',
        ecommerce: {
          purchase: {
            actionField: {
              id: order.id,
              revenue: format(order.total_price_paid),
              tax: format((order.total_price_paid || 0) * 0.2)
            },
            products: products
          }
        }
      })
    }

    resolve(payload)
  }))

  return null
}
